import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React, { useEffect, useState } from 'react';
import { createBrowserHistory } from 'history';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { render } from 'react-dom';
import ReactModal from 'react-modal';
import { ApolloProvider as ApolloHooksProvider } from "@apollo/client"
import 'font-awesome/css/font-awesome.min.css';
import './reset.css';
import drivoApollo from './lib/drivoApollo';

import ScrollToTop from './components/ScrollToTop';
import { AppConfigProvider } from './components/AppConfigContext';
import { InstallationSelector } from './components/InstallationSelector';
import { InstallationProvider } from './components/InstallationContext';
import App from './App';
import {ApolloProvider} from "@apollo/client";
import LoginPage from "./pages/Login";
import authManager from "./lib/authManager";
import { LoadingFork } from "./components/LoadingFork";
import RetryStripePaymentsPage from "./pages/Settings/RetryStripePayments";
import { RestProxyPage } from './components/RestProxyPage';

// Create Custom Sentry Route component
const SentryRoute = Sentry.withSentryRouting(Route);
const history = createBrowserHistory();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

// initialize react Modal behaviour
const appElement = document.getElementById('root');
ReactModal.setAppElement(appElement);
ReactModal.defaultStyles.overlay.backgroundColor = 'rgba(0,0,0,0.2)';
ReactModal.defaultStyles.overlay.zIndex = 100000;

render(
  <BrowserRouter>
    <ScrollToTop>
      <ApolloProvider client={drivoApollo}>
        <ApolloHooksProvider client={drivoApollo}>
          <AppConfigProvider>
            <Switch>
              <SentryRoute exact path="/" component={LoginPage} />

              <SentryRoute exact path="/refunds/:id/mark-as-processed" component={RestProxyPage} />
              <SentryRoute exact path="/payouts/:id/mark-as-processed" component={RestProxyPage} />
              <SentryRoute exact path="/cancellations/:id/mark-as-processed" component={RestProxyPage} />

              <SentryRoute exact path="/installations" component={InstallationSelector} />
              <SentryRoute exact path="/login" component={LoginPage} />
              <SentryRoute
                exact
                path="/retry-stripe-payments"
                render={() =>
                  !authManager.isAuthenticated ? (
                    <Redirect to="/login" />
                  ) : !authManager.isRootAdmin() ? (
                    <div style={{ padding: 24, textAlign: 'center' }}>
                      Access denied. Root admin only.
                    </div>
                  ) : (
                    <RetryStripePaymentsPage />
                  )
                }
              />
              <SentryRoute
                path='/:brandingKey'
                render={(props) => (
                  <InstallationProvider key={props.match.params.brandingKey} {...props}>
                    <App />
                  </InstallationProvider>
                )}
              />
            </Switch>
          </AppConfigProvider>
        </ApolloHooksProvider>
      </ApolloProvider>
    </ScrollToTop>
  </BrowserRouter>,
  appElement,
);
